module.exports = __webpack_public_path__ + "static/media/Logo_W.298627e0.svg";